import types from '../types'

const SIZE_PER_PAGE = 25

const initialState = {
  authorizations: {
	  loading: true,
    error: false,
    success: false,
    data: [],
    pagination: {
      sizePerPage: SIZE_PER_PAGE,
      totalSize: 0
    }
  },
  csvAuthorizations: {
	  loading: false,
    error: false,
    success: false,
    data: []
  },
  orgAuthorizations: {
	  loading: true,
    error: false,
    success: false,
    data: [],
    pagination: {
      sizePerPage: SIZE_PER_PAGE,
      totalSize: 0
    }
  },
  csvOrgAuthorizations: {
	  loading: false,
    error: false,
    success: false,
    data: []
  }
}

const authorizationReducer = (state = initialState, action) => {
  switch (action.type) {
	  case types.GET_AUTHORIZATIONS_REQUESTED: {
      if ( action.authType === 'CSV' ) {
        return {
          ...state,
          csvAuthorizations: {
            loading: true,
            error: false,
            success: false,
            data: []
          }
        }

      } else {
        return {
          ...state,
          authorizations: {
            loading: true,
            error: false,
            success: false,
            data: [],
            pagination: {
              sizePerPage: SIZE_PER_PAGE,
              totalSize: 0
            }
          }
        }
      }
    }
    case types.GET_AUTHORIZATIONS_FULFILLED: {
      if ( action.authType === 'CSV' ) {
        return {
          ...state,
          csvAuthorizations: {
            ...state.csvAuthorizations,
            loading: false,
            success: true,
            data: action.payload
          }
        }
      }
      else {
        return {
          ...state,
          authorizations: {
            ...state.authorizations,
            loading: false,
            success: true,
            data: action.payload.results,
            pagination: {
              sizePerPage: SIZE_PER_PAGE,
              totalSize: action.payload.total
            }
          }
        }
      }
    }
	  case types.GET_AUTHORIZATIONS_REJECTED: {
      if ( action.authType === 'CSV' ) {
        return {
          ...state,
          csvAuthorizations: {
            ...state.csvAuthorizations,
            loading: false,
            error: action.payload
          }
        } 
      } else {
        return {
          ...state,
          authorizations: {
            ...state.authorizations,
            loading: false,
            error: action.payload,
            pagination: {
              sizePerPage: SIZE_PER_PAGE,
              totalSize: 0
            }
          }
        }
      }
    }
	  case types.GET_ORG_AUTHORIZATIONS_REQUESTED: {
      if ( action.authType === 'CSV' ) {
        return {
          ...state,
          csvOrgAuthorizations: {
            loading: true,
            error: false,
            success: false,
            data: []
          }
        }
      }
      else {
        return {
          ...state,
          orgAuthorizations: {
            loading: true,
            error: false,
            success: false,
            data: [],
            pagination: {
              sizePerPage: SIZE_PER_PAGE,
              totalSize: 0
            }
          }
        }

      }
    }
    case types.GET_ORG_AUTHORIZATIONS_FULFILLED: {
      if ( action.authType === 'CSV' ) {
        return {
          ...state,
          csvOrgAuthorizations: {
            ...state.csvOrgAuthorizations,
            loading: false,
            success: true,
            data: action.payload
          }
        }
      } else {
        return {
          ...state,
          orgAuthorizations: {
            ...state.orgAuthorizations,
            loading: false,
            success: true,
            data: action.payload.results,
            pagination: {
              sizePerPage: SIZE_PER_PAGE,
              totalSize: action.payload.total
            }
          }
        }
      }
    }
	  case types.GET_ORG_AUTHORIZATIONS_REJECTED: {
      if ( action.authType === 'CSV' ) {
        return {
          ...state,
          csvOrgAuthorizations: {
            ...state.csvOrgAuthorizations,
            loading: false,
            error: action.payload
          }
        }
      } else {
        return {
          ...state,
          orgAuthorizations: {
            ...state.orgAuthorizations,
            loading: false,
            error: action.payload,
            pagination: {
              sizePerPage: SIZE_PER_PAGE,
              totalSize: 0
            }
          }
        }
      }
    }
    case types.CLEAR_CSV_AUTHORIZATIONS: {
      if ( action.csvType === 'ORG' ) {
        return {
          ...state,
          csvOrgAuthorizations: {
            loading: false,
            error: false,
            success: false,
            data: []
          }
        }
      } else {
        return {
          ...state,
          csvAuthorizations: {
            loading: false,
            error: false,
            success: false,
            data: []
          }
        }
      }
    }
    default: {
      return state
    }
  }
}

export default authorizationReducer